import { Inject, Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CURRENCY_PIPE } from '@brunsker/libs/core/features/generic-pipe/src';
import { UtilsBsHotToastService } from '@brunsker/libs/core/utils/hot-toast/src';
import { MapperService } from '@brunsker/libs/portal-do-vendedor/utils/portal-vendedor-api';
import { tap } from 'rxjs';
import {
  DadosPdfItemsResponse,
  DadosPdfResponse,
} from '../../../../models/orcamento.models';
import { NewApiOrcamentoService } from '../../../api/new-api-orcamento/new-api-orcamento.service';
import { ENVIRONMENT_TOKEN, Environment } from '@brunsker/libs/core/utils/http-log-interceptor/src';
@Injectable({
  providedIn: 'root',
})
export class PdfDomainService {
  pdfMake: any;
  pdfFonts: any;
  empresa?: string;
  casaRios?: boolean;
  orcaPed?: number;
  origemVenda?: string;
  notSearch: string = 'N/A';
  fenixLogoSize = 50;
  fenixLogoPosition = 1;
  genericLogoSize = 35;
  genericLogoPosition = 13;
  isFenix = this.environment.imageName.includes('fenixfoods');

  constructor(
    readonly mapperService: MapperService,
    readonly utilsBsHotToastService: UtilsBsHotToastService,
    private readonly newApiOrcamento: NewApiOrcamentoService,
    @Inject(ENVIRONMENT_TOKEN) readonly environment: Environment
  ) {
    this.pdfMake = require('pdfmake/build/pdfmake.js');
    this.pdfFonts = require('pdfmake/build/vfs_fonts.js');
    this.pdfMake.vfs = this.pdfFonts.pdfMake.vfs;
  }

  CURRENCY_PIPE = CURRENCY_PIPE;

  selectPdfModelGroup = new FormGroup({
    hasHeader: new FormControl(true),
    pdfControl: new FormControl(null as any, Validators.required),
  });

  getBase64ImageFromURL(url: string) {
    return new Promise<string>((resolve, reject) => {
      var img = new Image();
      img.setAttribute('crossOrigin', 'anonymous');

      img.onload = () => {
        var canvas = document.createElement('canvas');

        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext('2d');

        if (url=="assets/svgs/logo-brunsker.svg"){
          ctx!.fillStyle = 'rgba(0,0,0,0.3)';
          ctx!.fillRect(0, 0, canvas.width, canvas.height);
          ctx!.globalCompositeOperation = "destination-in";
        }
        ctx?.drawImage(img, 0, 0);

        var dataURL = canvas.toDataURL('image/png');

        resolve(dataURL);
      };

      img.onerror = (error) => {
        reject(error);
      };

      img.src = url;
    });
  }

  start(seQ_PEDIDO: number, casaRios?: boolean, orcaPed?: number, origemVenda?: string, empresa?:string): void {
    this.casaRios = casaRios;
    this.orcaPed = orcaPed;
    this.origemVenda = origemVenda;
    this.empresa = empresa;
    this.newApiOrcamento
      .getDataPdf(seQ_PEDIDO)
      .pipe(
        tap((value) => {
          if (!value || value.items.length === 0) {
            this.utilsBsHotToastService.showError(
              'Não foi possivel executar esta ação!'
            );
          }
        })
      )
      .subscribe(async (orcamento: DadosPdfResponse) => {
        this.generatePdf(orcamento, seQ_PEDIDO);
      });
  }

  async generatePdf(orcamento: DadosPdfResponse, seQ_PEDIDO: number) {
    const totalSum = (orcamento: DadosPdfResponse) => {
      const pdfControl = this.selectPdfModelGroup.controls['pdfControl'];

      return orcamento.items.reduce((acc, curr) => {
        const valorProduto =
          pdfControl.value === 2 || pdfControl.value === 4
            ? curr.valorTabelaProduto
            : curr.valorVendaProduto;
        return acc + valorProduto;
      }, 0);
    };

    const hasHeader = !this.selectPdfModelGroup.controls['hasHeader'].value;

    const borderPage = [
      {
        canvas: [
          { type: 'line', x1: 5, y1: 5, x2: 590, y2: 5, lineWidth: 1 },
          { type: 'line', x1: 5, y1: 5, x2: 5, y2: 835, lineWidth: 1 },
          { type: 'line', x1: 5, y1: 835, x2: 590, y2: 835, lineWidth: 1 },
          { type: 'line', x1: 590, y1: 5, x2: 590, y2: 835, lineWidth: 1 },
        ],
      },
    ];

    const logo = await this.getBase64ImageFromURL(
      `assets/svgs/portal-client-${this.environment.imageName}-pdf.svg`
    );
    const logoBrunsker = await this.getBase64ImageFromURL(
      `assets/svgs/logo-brunsker.svg`
    );
    const fontSizeHeader = 9;
    const fontSizeBody = 8;
    const fontSizeSmallBody = 6;
    const fontSizeSmallHeader = 7;
    const nonFiscalDocument = {
      text: 'Não é Documento Fiscal - Não é válido como recibo e como garantia de mercadoria - Não comprova pagamento',
      fontSize: 9,
      bold: true,
      absolutePosition: { x: 100, y: 10 },
    };

    const tableBreak = orcamento.items.length >= 7;

    const marginValue = tableBreak ? 125 : 140;

    const line = () => {
      return {
        canvas: [
          {
            relativePosition: { x: -55, y: 0 },
            type: 'line',
            x1: -35,
            y1: 15,
            x2: 550,
            y2: 15,
            lineWidth: 1,
          },
        ],
      };
    };
    const headerFontSize = 8.5;

    const position = this.isFenix
      ? this.fenixLogoPosition
      : this.genericLogoPosition;

    const height = this.isFenix ? this.fenixLogoSize : this.genericLogoSize;

    let pageMargins = 60;

    const headerPDF = {
      columns: [
        nonFiscalDocument,
        {
          image: logo,
          fit: [60, height],
          margin: [0, 0, 0, 0],
          absolutePosition: { x: position, y: position },
        }
      ],
    };

    if(orcamento.telefoneEmpresa)
    {
      pageMargins = pageMargins + 10;
      headerPDF.columns.push({
        text: orcamento.telefoneEmpresa
          ? `TELEFONE: ${orcamento.telefoneEmpresa ?? this.notSearch}`
          : '',
        fontSize: headerFontSize,
        bold: true,
        absolutePosition: { x: 90, y: 45 },
      })
    }

    if(orcamento.fax)
    {
      pageMargins = pageMargins + 10;
      headerPDF.columns.push({
        text: orcamento.fax
          ? `CELULAR: ${orcamento.fax ?? this.notSearch}`
          : '',
        fontSize: headerFontSize,
        bold: true,
        absolutePosition: { x: 90, y: 55 },
      })
    }

    headerPDF.columns.push({
      text: `${this.empresa}`,
      fontSize: headerFontSize,
      bold: true,
      absolutePosition: { x: 90, y: 30 },
    })

    headerPDF.columns.push({
      text: `DATA EMISSÃO: ${new Date(
        orcamento.dataOrcamento
      ).toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })}`,
      fontSize: headerFontSize,
      bold: true,
      absolutePosition: { x: 450, y: 30 },
    })

    const informacoesCliente = [
      {
        text: `INFORMAÇÕES DO CLIENTE`,
        alignment: 'center',
        style: 'header',
        fontSize: 8,
        bold: true,
        headlineLevel: 1,
        relativePosition: { x: 0, y: 30+15 },
      },
      {
        text: `CLIENTE: ${orcamento.idCliente} - ${orcamento.nomeCliente} - ${orcamento.documentoCliente}`,
        fontSize: 8,
        bold: true,
        relativePosition: { x: 0, y: 43+15 },
      },
      {
        text: `TELEFONE: ${orcamento.telefoneCliente ?? this.notSearch} ${
          orcamento.celularCliente ? `| ${orcamento.celularCliente}` : ''
        }`,
        fontSize: 8,
        bold: true,
        relativePosition: { x: 370, y: 43+15 },
      },
    ];

    const titlePdf = [
      {
        text: `DADOS DO ${this.orcaPed!=0 ?'PEDIDO' :'ORÇAMENTO'}`,
        alignment: 'center',
        style: 'header',
        fontSize: 8,
        bold: true,
        relativePosition: { x: 0, y: -10 },
      },
      {
        text: `VENDEDOR: ${`${orcamento.idVendedor ?? this.notSearch} - ${
          orcamento.nomeVendedor ?? this.notSearch
        }`.substring(0, 30)}`,
        fontSize: 8,
        bold: true,
        relativePosition: { x: 0, y: 2 },
      },
      {
        text: `NUMERO ${this.orcaPed!=0 ?'PEDIDO' :'ORÇAMENTO'} PDV: ${orcamento.idOrcamento} | ${seQ_PEDIDO} - ${
          orcamento.idFilial ?? this.notSearch
        }`,
        fontSize: 8,
        bold: true,
        relativePosition: { x: 370, y: 2 },
      },
      {
        text: `FORMA DE PAGAMENTO: ${orcamento.idCobranca ?? this.notSearch} - ${
          orcamento.planoPagamentoCobranca ?? this.notSearch
        }`,
        fontSize: 8,
        bold: true,
        relativePosition: { x: 0, y: 15 },
      },
      {
        text: `TV${orcamento.tipoVenda}`,
        fontSize: headerFontSize,
        bold: true,
        relativePosition: { x: 290, y: 15 },
      },
      {
        text: `VALIDADE: 1 DIA APÓS DATA EMISSÃO`,
        fontSize: 8,
        bold: true,
        relativePosition: { x: 370, y: 15 },
      },
      {
        text: `PRAZO DE PAGAMENTO: ${
          orcamento.planoPagamento ?? this.notSearch
        }`,
        fontSize: 8,
        bold: true,
        relativePosition: { x: 0, y: 28 },
      },
      {
        text: `ORIGEM DE VENDA: ${this.origemVenda ?this.origemVenda : '-'}`,
        fontSize: headerFontSize,
        bold: true,
        relativePosition: { x: 370, y: 28 },
      },
      {
        text: orcamento.telefoneVendedor
          ? `CEL VENDEDOR: ${orcamento.telefoneVendedor ?? this.notSearch}`
          : '',
        fontSize: 8,
        bold: true,
        relativePosition: { x: -30, y: 15 },
      },
    ];

    const tableProduct = (
      itemProduct: DadosPdfItemsResponse,
      index: number
    ) => {
      const pdfControl = this.selectPdfModelGroup.controls['pdfControl'];
      const descricao =
        pdfControl.value === 2 || pdfControl.value === 4
          ? itemProduct.descricao ?? itemProduct.nomeProduto
          : itemProduct.nomeProduto ?? itemProduct.descricao;

      const valorProduto =
        pdfControl.value === 1 || pdfControl.value === 2 //|| pdfControl.value === 3
          ? itemProduct.valorTabelaProduto
          : itemProduct.valorVendaProduto;

      return [
        { text: index ?? '', alignment: 'center' },
        { text: itemProduct.idProduto, alignment: 'center' },
        descricao,
        { text: itemProduct.unidadeMaster, alignment: 'center' },
        { text: itemProduct.quantidadeProduto, alignment: 'center' },
        `R$ ${valorProduto.toFixed(2)}`,
        `R$ ${(itemProduct.quantidadeProduto * valorProduto).toFixed(2)}`,
      ];
    };

    const tableHeaders = [
      { text: 'ITEM', bold: true },
      { text: 'CÓDIGO', bold: true },
      { text: 'DESCRIÇÃO', bold: true },
      { text: 'UNIDADE', bold: true },
      { text: 'QUANT', bold: true },
      { text: 'PREÇO UNITARIO', alignment: 'center', bold: true },
      { text: 'VALOR TOTAL', alignment: 'center', bold: true },
    ];

    const generateRoomLabel = (label: string) => {
      return {
        text: `Ambiente: ${label ? label.toLocaleUpperCase() : ''}`,
        alignment: 'left',
        fontSize: 8,
        bold: true,
        headlineLevel: 1,
        // left - top - right - bottom
        margin: [0, 0, 0, 4],
      };
    };

    const generateRoomTable = (room: string) => {
      return {
        fontSize: 8,
        style: 'tableStyle',
        table: {
          headerRows: 2,
          widths: Array.from({ length: tableHeaders.length }, (_, index) => {
            if (index === 0) {
              return 20;
            }
            if (index === 1) {
              return 30;
            }
            if (index === 2) {
              return 180;
            }

            if (index === 3) {
              return 35;
            }

            if (index === 4) {
              return 30;
            }

            return '*';
          }),
          heights: Array.from({ length: tableHeaders.length }, (_, index) => {
            return '*';
          }),

          body: [
            JSON.parse(JSON.stringify(tableHeaders)),
            ...orcamento.items
              .filter((item) => item.ambiente === room)
              .sort((itemA: any, itemB: any) => {
                const pdfControl =
                  this.selectPdfModelGroup.controls['pdfControl'];
                const descricao =
                  pdfControl.value === 2 || pdfControl.value === 4
                    ? 'descricao'
                    : 'nomeProduto';

                return itemA[descricao]?.localeCompare(itemB[descricao]);
              })
              .map((itemProduct: DadosPdfItemsResponse, index: number) =>
                tableProduct(itemProduct, index + 1)
              ),
          ],
        },

        layout: {
          margin: [0, 0, 0, 0],
        },
      };
    };

    const generateRoomsDistribution = () => {
      const rooms: string[] = [];
      orcamento.items.forEach((item) => {
        if (!rooms.includes(item.ambiente)) rooms.push(item.ambiente);
      });

      const tablesPerRoom: any[] = [];
      rooms.forEach((room) => {
        tablesPerRoom.push(generateRoomLabel(room));
        tablesPerRoom.push(generateRoomTable(room));
        generateRoomBottomTable(room, tablesPerRoom);
      });
      return tablesPerRoom;
    };

    const formatPriceValues = (price: number) => {
      return price.toFixed(2).replace('.', ',');
    };

    const generateRoomBottomTable = (room: string, tablesPerRoom: any[]) => {
      // @TOIMPROVE: se tiver separação por ambiente
      if (true) {
        const filteredItems = orcamento.items.filter(
          (item) => item.ambiente === room
        );
        let totalRoom = 0;
        if (filteredItems.length > 0) {
          totalRoom = filteredItems.reduce((prev, curr) => {
            prev.valorTotal += curr.valorTotal;
            return prev;
          }).valorTotal;
        }
        let precoTotal = {
          margin: [0, 0, 0, 16],
          lineHeight: 0.4,
          alignment: 'right',
          fontSize: 9.5,
          bold: true,
          text: `
            TOTAL DO AMBIENTE: R$ ${formatPriceValues(totalRoom)}
            `,
        }

        let totalProdutos = {
          margin: [0, -24, 0, 0],
          lineHeight: 0.4,
          alignment: 'left',
          fontSize: 9.5,
          bold: true,
          text: `TOTAL DE ITENS: ${orcamento.items.length}`,
        }

        tablesPerRoom.push(precoTotal)
        tablesPerRoom.push(totalProdutos)
      }
    };

    const generateBottomTable = () => {
      const pdfControl = this.selectPdfModelGroup.controls['pdfControl'];

      if (pdfControl.value === 3 || pdfControl.value === 4)
        return {
          margin: [0, 15, 0, 0],
          lineHeight: 1.2,
          fontSize: 9.5,
          alignment: 'right',
          text: `SUBTOTAL: R$ ${formatPriceValues(
            orcamento.valorTotal - orcamento.valorFrete
          )}
          FRETE: R$ ${formatPriceValues(orcamento.valorFrete)}
          TOTAL GERAL: R$ ${formatPriceValues(orcamento.valorTotal)}
          `,
        };

      return {
        margin: [0, 15, 0, 0],
        lineHeight: 1.2,
        alignment: 'right',
        fontSize: 9.5,
        bold: true,
        text: `SUBTOTAL: R$ ${formatPriceValues(orcamento.subTotal)}
          FRETE: R$ ${formatPriceValues(orcamento.valorFrete)}
          DESCONTO TOTAL: R$ ${formatPriceValues(orcamento.desconto)}
          TOTAL GERAL: R$ ${formatPriceValues(orcamento.valorTotal)}
          `,
      };
    };

    const texte = this.casaRios
      ? `
        * NÃO ACEITAMOS TROCA OU DEVOLUÇÃO DE:
          - PRODUTOS COMERCIAIS "B", "C", 'STANDART";
          - PRODUTOS SOB ENCOMENDA;
          - TINTAS SUVINIL SELFCOLOR (FEITAS NA MÁQUINA);
          - REVESTIMENTOS (PISOS/AZULEJOS/PORCELANATOS) COM NOSSO ESTOQUE INFERIOR A 30M² DA MESMA TONALIDADE E BITOLA.
        * PEÇAS EM NOSSOS SHOWROOMS SÃO AMOSTRAS REFERENCIAIS PODENDO HAVER VARIAÇÃO DE TONALIDADE.
        * CONFIRA OS PRODUTOS NO ATO DA ENTREGA. NÃO ACEITAREMOS RECLAMAÇÕES POSTERIORES.
        * DEVOLUÇÕES OU TROCAS SOMENTE SERÃO ACEITAS ATÉ 30 DIAS APÓS A COMPRA, MEDIANTE APRESENTAÇÃO DE NOTA FISCAL OU CUPOM E COM EMBALAGENS PERFEITAS.
        * A VALIDADE DO ORÇAMENTO NÃO INCLUI PRODUTOS EM PROMOÇÃO.
      `
      : `
        * NÃO ACEITAMOS TROCA OU DEVOLUÇÃO DE:
          - PRODUTOS SOB ENCOMENDA;
        * CONFIRA OS PRODUTOS NO ATO DA ENTREGA. NÃO ACEITAREMOS RECLAMAÇÕES POSTERIORES.
        * DEVOLUÇÕES OU TROCAS SOMENTE SERÃO ACEITAS ATÉ 15 DIAS APÓS A COMPRA COM EMBALAGENS PERFEITAS.

      `;

    const documentDefinitions = {
      pageSize: 'A4',
      pageMargins: [40, pageMargins],

      background: (currentPage: number, pageSize: number) => borderPage,

      header: (currentPage: number, pageCount: number) => {
        if (hasHeader) return nonFiscalDocument;

        return headerPDF;
      },

      footer: {
        columns: [
          {
            image: logoBrunsker,
            width: 90,
            margin: [0, 0, 0, 0],
            absolutePosition: { x: 480, y: 25 },
          },
        ],
      },

      content: [
        hasHeader
          ? {}
          : {
              relativePosition: { x: 0, y: -27 },
              ...line(),
            },
        ,
        titlePdf,
        {
          relativePosition: { x: 0, y: 12+15 },
          ...line(),
        },
        ...informacoesCliente,
        {
          relativePosition: { x: 0, y: 45+15 },
          ...line(),
        },
        {
          text: `${this.orcaPed ?'PEDIDO' :'ORÇAMENTO'}${this.orcaPed ?" - "+this.orcaPed : ''}` ,
          alignment: 'center',
          style: 'header',
          fontSize: 16,
          bold: true,
          headlineLevel: 1,
          margin: [0, 80+10, 0, 10],
        },
        generateRoomsDistribution(),
        generateBottomTable(),
        {
          fontSize: 8,
          bold: true,
          text: 'Assinatura do Cliente',
          alignment: 'center',
        },
        {
          relativePosition: { x: 200, y: -30 },
          canvas: [
            {
              type: 'line',
              x1: -35,
              y1: 15,
              x2: 150,
              y2: 15,
              lineWidth: 1,
            },
          ],
        },
        line(),
        {
          text: `OBSERVAÇÕES`,
          alignment: 'center',
          style: 'header',
          fontSize: 10,
          bold: true,
          headlineLevel: 1,
          margin: [0, 10, 0, 0],
        },
        {
          fontSize: fontSizeHeader,
          text: [`ENDEREÇO DE ENTREGA`],
          relativePosition: { x: 0, y: 10 },
          bold: true,
          alignment: 'left',
        },
        {
          fontSize: fontSizeHeader,
          text: [`DESTINARIO: ${orcamento.nomeCliente ?? this.notSearch}`],
          relativePosition: { x: 0, y: 20 },
          bold: true,
          alignment: 'left',
        },
        {
          fontSize: fontSizeHeader,
          text: [`ENDEREÇO: ${orcamento.enderecoCliente ?? this.notSearch}`],
          relativePosition: { x: 0, y: 30 },
          bold: true,
          alignment: 'left',
        },
        {
          fontSize: fontSizeHeader,
          text: [`N: ${orcamento.numeroCliente ?? this.notSearch}`],
          relativePosition: { x: 230, y: 30 },
          bold: true,
          alignment: 'left',
        },
        {
          fontSize: fontSizeHeader,
          text: [`BAIRRO: ${orcamento.bairroCliente}`],
          relativePosition: { x: 270, y: 30 },
          bold: true,
          alignment: 'left',
        },
        {
          fontSize: fontSizeHeader,
          text: [`CIDADE:${orcamento.cidadeCliente}`],
          relativePosition: { x: 430, y: 30 },
          bold: true,
          alignment: 'left',
        },
        {
          fontSize: fontSizeHeader,
          text: [
            `OBSERVAÇÕES GERAIS:

            `,
            {
              text: `${orcamento.observacaoOrcamento ?? ''}
              ${orcamento.observacaoOrcamento2 ?? ''}
                ${orcamento.observacaoOrcamento3 ?? ''}
              `,

              fontSize: fontSizeSmallHeader,
            },
          ],
          relativePosition: { x: 0, y: 70 },
          bold: true,
          alignment: 'left',
        },
        {
          fontSize: fontSizeHeader,
          title: 'Nome',
          text: [
            `OBSERVAÇÕES DE ENTREGA:

            `,

            {
              text: `${orcamento.observacaoEntrega ?? ''}
              ${orcamento.observacaoEntrega2 ?? ''}
              ${orcamento.observacaoEntrega3 ?? ''}
              `,
              fontSize: fontSizeSmallHeader,
            },
          ],

          bold: true,
          alignment: 'left',
          relativePosition: { x: 265, y: 70 },
        },

        {
          relativePosition: { x: 0, y: 90 },
          text: '',
        },
        {
          text: ``,
          alignment: 'center',
          style: 'header',
          fontSize: 8,
          bold: true,
          margin: [0, marginValue, 0, 0],
        },
        {
          text: texte,
          style: 'header',
          fontSize: 7.5,
          bold: true,
          headlineLevel: 1,
        },
      ],
    };

    this.pdfMake.createPdf(documentDefinitions).open();
  }
}
